// // components/InfoCards.jsx
// import { useDispatch, useSelector } from "react-redux";
// import "./InfoCards.css";
// import { AllAboutUs } from "../../../features/admin/common/Slice";
// import { useEffect } from "react";

// export default function InfoCards() {
//   const dispatch = useDispatch();

//   const all_about_us = useSelector((state) => state?.common?.all_about_us);


//   useEffect(() => {
//     dispatch(AllAboutUs());
//   }, [dispatch]);
//   const cards = [
//     {
//       title: "Our Vision",
//       text:
//         "To become a trusted wellness brand that improves everyday health through a single, powerful natural product while creating sustainable growth opportunities for our community.",
//       image: "/images/about/component26-1.png",
//     },
//     {
//       title: "Our Mission",
//       text:
//         "To deliver pure, high-quality spirulina that supports better nutrition & well-being, while empowering individuals to grow through a transparent, ethical, & community-driven referral system.",
//       image: "/images/about/component27-1.png",
//     },
//     {
//       title: "Our Value",
//       text:
//         "We are committed to transparency, quality, & trust in everything we do. Our focus is on ethical growth, community success, & delivering real value through one powerful wellness product.",
//       image: "/images/about/component28-1.png",
//     },
//   ];

//   return (
//     <section className="InfoCards">
//       <div>
//         <div className="cards-container">
//           {cards.map((card, index) => (
//             <div className="card">
//               <div className="card-img-wrapper">
//                 <img src={card.image} alt={card.title} className="card-img" />
//               </div>
//               <div className="card-content">
//                 <h3>{card.title}</h3>
//                 <p>{card.text}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// components/InfoCards.jsx
import { useDispatch, useSelector } from "react-redux";
import "./InfoCards.css";
import { AllAboutUs } from "../../../features/admin/common/Slice";
import { useEffect } from "react";
import { IDS } from "../../../utils/IDS";

// Assuming this is defined somewhere (env / constants file)
const IMG_BASE_URL = "https://your-api-domain.com/"; // ← adjust this

export default function InfoCards() {
  const dispatch = useDispatch();
  const all_about_us = useSelector((state) => state?.common?.all_about_us);

  useEffect(() => {
    dispatch(AllAboutUs());
  }, [dispatch]);


  // Convert single object → array of 3 card objects
  const cards = all_about_us
    ? [
        {
          title: "Our Vision",
          text:
            all_about_us?.our_vision_discription || "Our vision description",
          image: all_about_us?.our_vision_image,
        },
        {
          title: "Our Mission",
          text:
            all_about_us?.our_mission_discription || "Our mission description",
          image: all_about_us?.our_mission_image,
        },
        {
          title: "Our Value", // ← consider renaming to "Our Values"
          text: all_about_us?.our_value_discription || "Our value description",
          image: all_about_us?.our_value_image,
        },
      ]
    : [];

  return (
    <section className="InfoCards">
      <div className="cards-container">
        {cards?.map((card, index) => (
          <div className="card" key={index}>
            <div className="card-img-wrapper">
              <img
                src={`${IDS.IMG_URL}${card?.image}`}
                alt={card?.title}
                className="card-img"
                onError={(e) => {
                  e.target.src = "/images/fallback-card.jpg"; // optional fallback
                }}
              />
            </div>
            <div className="card-content">
              <h3>{card.title}</h3>
              <p>{card.text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
